import config from "../../config";
import { ActionsStatus, EventStatus } from "../../types/status";

export const getStatusInfos = (
  type: "events" | "actions",
  status: EventStatus | ActionsStatus,
) => {
  const _status = config[type === "actions" ? "actionStatus" : "eventStatus"];

  // TODO Max TS
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const info = _status[status];

  return {
    label: info?.label || "Not found",
    color: info?.color || "grey",
  };
};
